module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAABFCAYAAADevW+tAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAMFJREFUaIHt27EJAkEUBuG3cnWoCKKpgRcZyZViZAkXGljCVSMWoA1oIgpWIYfagMGKMHgwX/wvzCtg07gf96qMNjLsj/E8XV+jnO03psN0Wc6jl7PdHaIoqjLapo5BzoPVJs6/5X22mMWjqWOSs11v45Z13b8xmmI0xWiK0RSjKUZTjKYYTTGaYjTFaIrRFKMpRlOMphhNMZpiNMVoitEUoylGU4ymGE0xmmI0xWiK0RSjKUZTjKYYTelkdOrin4A3HAQfrKyvFE4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /src/assets/images/Hold.png
// module id = 9ug7
// module chunks = 1